import { TypeOfWork } from '@pflegia/types/api/candidate/type-of-work';
import { FunnelQuestion } from '@pflegia/types/api/funnel/questions';
import { JobTitleEnum } from '@pflegia/types/api/job-title/job-titles.enum';
import { YesNoInProgress } from '@pflegia/types/common/enums/yes-no-in-progress.enum';
import { FunnelAnswers } from '@pflegia/ui/pflegia/funnel/types/funnel-answers';

export const isPhysiotherapyWithPraxismanagerWithNoQualification = (answers: FunnelAnswers): boolean => {
  const typesOfWork = answers[FunnelQuestion.EmployeeType];
  if (!typesOfWork) return false;

  return (
    typesOfWork.includes(TypeOfWork.Physiotherapy) &&
    answers[FunnelQuestion.JobTitle]?.title === JobTitleEnum.PracticeManager &&
    answers[FunnelQuestion.AQualification] === YesNoInProgress.No
  );
};
